import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "observer",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ invalid, handleSubmit }) {
          return [
            _c(
              VForm,
              {
                ref: "form",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    handleSubmit(_vm.buttonOnClick("submit", invalid))
                  },
                },
                model: {
                  value: _vm.fromIsValid,
                  callback: function ($$v) {
                    _vm.fromIsValid = $$v
                  },
                  expression: "fromIsValid",
                },
              },
              [
                _c("p", [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]),
                _vm._v(" "),
                _vm._l(_vm.fields, function (row, i) {
                  return _c(
                    VRow,
                    { key: "form_element_" + i },
                    [
                      _vm._l(row, function (col, fieldKey) {
                        return [
                          _vm.appAllowAccess(
                            col.authenticated ? col.authenticated : false,
                            col.roles ? col.roles : [],
                            col.permissions ? col.permissions : []
                          )
                            ? _c(
                                "div",
                                { key: fieldKey, class: col.column + " py-1" },
                                [
                                  _c("input-rules-wrapper", {
                                    attrs: { rules: col.rules },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              col.type === "section"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "h2",
                                                        { class: col.class },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                col.title
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(VDivider),
                                                    ],
                                                    1
                                                  )
                                                : _vm.checkRegisteredComps(
                                                    col.component
                                                  )
                                                ? _c(
                                                    col.component,
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          tag: "component",
                                                          on: {
                                                            keyup:
                                                              _vm.focusNext,
                                                            "upload-done":
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.uploadDone =
                                                                  $event
                                                              },
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              _vm._l(
                                                                _vm.scopedSlotNamesOnly,
                                                                function (
                                                                  slot
                                                                ) {
                                                                  return {
                                                                    key: _vm.fieldSlotName(
                                                                      slot,
                                                                      fieldKey
                                                                    ),
                                                                    fn: function (
                                                                      scope
                                                                    ) {
                                                                      return [
                                                                        _vm._t(
                                                                          slot,
                                                                          null,
                                                                          null,
                                                                          scope
                                                                        ),
                                                                      ]
                                                                    },
                                                                  }
                                                                }
                                                              ),
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                          model: {
                                                            value:
                                                              _vm.fieldModel[
                                                                fieldKey
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.fieldModel,
                                                                fieldKey,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "fieldModel[fieldKey]",
                                                          },
                                                        },
                                                        "component",
                                                        {
                                                          ...col.props,
                                                          ...attrs,
                                                        },
                                                        false
                                                      ),
                                                      { ...on }
                                                    ),
                                                    [
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.slotNamesOnly,
                                                        function (slot) {
                                                          return [
                                                            _vm._t(slot, null, {
                                                              slot: _vm.fieldSlotName(
                                                                slot,
                                                                fieldKey
                                                              ),
                                                            }),
                                                          ]
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                : _vm._t(col.component, null, {
                                                    value:
                                                      _vm.fieldModel[fieldKey],
                                                    props: {
                                                      ...attrs,
                                                      ...col.props,
                                                    },
                                                    update: (event) => {
                                                      _vm.$set(
                                                        _vm.fieldModel,
                                                        fieldKey,
                                                        event
                                                      )
                                                    },
                                                  }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c(
                  VCardActions,
                  [
                    _vm.mergeButton("cancel").show
                      ? _c(
                          "ActionButton",
                          _vm._b(
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.buttonOnClick("cancel")
                                },
                              },
                            },
                            "ActionButton",
                            _vm.mergeButton("cancel").props,
                            false
                          )
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mergeButton("clear").show
                      ? _c(
                          "ActionButton",
                          _vm._b(
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.buttonOnClick("clear")
                                },
                              },
                            },
                            "ActionButton",
                            _vm.mergeButton("clear").props,
                            false
                          )
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mergeButton("reset").show
                      ? _c(
                          "ActionButton",
                          _vm._b(
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.buttonOnClick("reset")
                                },
                              },
                            },
                            "ActionButton",
                            _vm.mergeButton("reset").props,
                            false
                          )
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(VSpacer),
                    _vm._v(" "),
                    _vm.mergeButton("submit").show
                      ? _c(
                          "ActionButton",
                          _vm._b(
                            { attrs: { type: "submit" } },
                            "ActionButton",
                            _vm.mergeButton("submit").props,
                            false
                          )
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              2
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }